
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
export const Regex = () =>{


const functionCopy=(event)=>{
    let buttonCopy = event.target
    let copyText = buttonCopy.previousElementSibling
    let alertCopy = buttonCopy.nextElementSibling
    copyText.select();
    document.execCommand("copy");
    alertCopy.classList.add('js_copied');
    let temp = setInterval(function () {
        alertCopy.classList.remove('js_copied');
        clearInterval(temp);
    }, 600);
}
    return(
    
        <div id="articleContent" className="Regex">
       
       <a class="button only" href="https://regexr.com/" target="_blank">Regex tester !</a>
                    <h2>Exemples de Regex</h2>
                    <table id="regexExamples">
                        <thead>
                            <tr>
                                <th>Utilisation</th>
                                <th>Format</th>
                                <th>Regex</th>
                            </tr>
                        </thead>
                        <tr>
                            <td>Date</td>
                            <td>
                                <ul>
                                    <li>16/08/1986</li>
                                    <li>16-08-1986</li>
                                </ul>
                            </td>
                            <td>
                                <input type="text" value="^[0-9]{2}[-/]{1}[0-9]{2}[-/]{1}[0-9]{4}$"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                                
                            </td>
                        </tr>
                        <tr>
                            <td>Pseudo</td>
                            <td>m.al_ika-l</td>
                            <td>
                                <input type="text" value="^[0-9a-zA-Z._-]{3,20}$"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Adresse email</td>
                            <td>name@domaine.fr</td>
                            <td>
                                <input type="text"
                                    value="^[a-z0-9\-_]+[a-z0-9\.\-_]*@[a-z0-9\-_{2,}\.[a-z\.\-_]+[a-z\-_]+$"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Url (début)</td>
                            <td>
                                <ul>
                                    <li>http://loremipsum</li>
                                    <li>https://loremipsum</li>
                                </ul>
                            </td>
                            <td>
                                <input type="text" value="(ht|f)tps?:\/\/\S*"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Téléphone format français</td>
                            <td>0154852584</td>
                            <td>
                                <input type="text" value="^[0]+[1-9][0-9]{0,8}$"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Téléphone internationnal OU français</td>
                            <td>
                                <ul>
                                    <li>+336548474548485</li>
                                    <li>0154852584</li>
                                </ul>
                            </td>
                            <td>
                                <input type="text" value="(^(\+\d{0,15})$)|(^[0]+[1-9][0-9]{0,8}$)"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Mot de passe</td>
                            <td>Mm@4zzzzzzzzzzzzzzzzzz</td>
                            <td>
                                <input type="text" value="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Uniquement un nombre</td>
                            <td>123456789</td>
                            <td>
                                <input type="text" value="^\d+$"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Champ vide</td>
                            <td>""</td>
                            <td>
                                <input type="text" value="^$"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Uniquement du texte (min et maj avec les options gi)</td>
                            <td>LoremIpsumDolorSit</td>
                            <td>
                                <input type="text" value="/^[a-z]*$/gi"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Pour éviter les injections</td>
                            <td>Lorem Ipsum - <br/>dolor sit* ...</td>
                            <td>
                                <input type="text" value="^[^<>{}]*$"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Nom ou prénom</td>
                            <td>
                                <li>Nom unique obligatoire + noms supplémentaires facultatifs + espaces + caractères
                                    spéciaux</li></td>
                            <td>
                                <input type="text" value="^(\s)*[A-Za-z]+((\s)?((\'|\-|\.)?([A-Za-z])+))*(\s)*$"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Nom ou prénom</td>
                            <td>
                                <li>Nom unique obligatoire + noms supplémentaires facultatifs + espace, SANS caractère
                                    spécial</li></td>
                            <td>
                                <input type="text" value="^[A-Za-z]+((\s)?([A-Za-z])+)*$"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Nom ou prénom</td>
                            <td>
                                <li>Nom unique obligatoire SANS espace, SANS caractère spécial</li>
                                </td>
                            <td>
                                <input type="text" value="^([A-Za-z])+$"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Nom ou prénom</td>
                            <td>
                                <li>Nom unique obligatoire SANS espace, AVEC caractère spécial</li>
                                </td>
                            <td>
                                <input type="text" value="^[A-Za-z]+(((\'|\-|\.)?([A-Za-z])+))?$"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Nom ou prénom</td>
                            <td>
                                <li>Nom unique obligatoire AVEC espace, AVEC caractère spécial</li>
                                </td>
                            <td>
                                <input type="text" value="^[A-Za-z]+((\s)?((\'|\-|\.)?([A-Za-z])+))*$"/>
                                <button class="btn-copy" type="button" onClick={(event) => {functionCopy(event) }}>Copier</button>
                                <span aria-hidden="true">Copié !</span>
                            </td>
                        </tr>
                    </table>

                    <div class="pageBreak"></div>
                    <h2>Tableau des motifs</h2>
                    <table class="p1002080">
                       
                        <tr>
                            <td colspan="2">Repérage début et fin de chaîne</td>
                        </tr>
                        <tr>
                            <td>^</td>
                            <td>Début de ligne ou de chaîne</td>
                        </tr>
                        <tr>
                            <td>$</td>
                            <td>Fin de ligne ou de chaîne</td>
                        </tr>
                        <tr>
                            <td colspan="2">Identification des caractères</td>
                        </tr>
                        <tr>
                            <td>.</td>
                            <td>N'importe quel caractère</td>
                        </tr>
                        <tr>
                            <td>ab|cd</td>
                            <td>Chaîne ab ou cd</td>
                        </tr>
                        <tr>
                            <td>[abcd]</td>
                            <td>Groupe de caractères : n'importe lequel de ceux entre crochets</td>
                        </tr>
                        <tr>
                            <td>[a-z]</td>
                            <td>Groupe de caractères : n'importe lequel de a à z</td>
                        </tr>
                        <tr>
                            <td>[A-Z]</td>
                            <td>Groupe de caractères : n'importe lequel de A à Z</td>
                        </tr>
                        <tr>
                            <td>[^0-9]</td>
                            <td>Groupe de caractères inverse : tous sauf ceux définis par les crochets</td>
                        </tr>
                        <tr>
                            <td>\</td>
                            <td>Ne s'utilise jamais seul, sert de caractère d'échappement</td>
                        </tr>
                        <tr>
                            <td>\\</td>
                            <td>Caractère \</td>
                        </tr>
                        <tr>
                            <td>\t</td>
                            <td>Tabulation</td>
                        </tr>
                        <tr>
                            <td>\n</td>
                            <td>Saut de ligne</td>
                        </tr>
                        <tr>
                            <td>\r</td>
                            <td>Saut de ligne</td>
                        </tr>
                        <tr>
                            <td>\f</td>
                            <td>Saut de page pour l'impression</td>
                        </tr>
                        <tr>
                            <td colspan="2">Comptage des caractères</td>
                        </tr>
                        <tr>
                            <td>*</td>
                            <td>Caractère précédent facultatif ou présent un nombre illimité de fois</td>
                        </tr>
                        <tr>
                            <td>+</td>
                            <td>Caractère précédent au moins un fois</td>
                        </tr>
                        <tr>
                            <td>?</td>
                            <td>Caractère précédent présent une et une seule fois ou absent</td>
                        </tr>
                        <tr>
                            <td>{'{n}'}</td>
                            <td>Caractère précédent présent exactement n fois</td>
                        </tr>
                        <tr>
                            <td>{'{n,}'}</td>
                            <td>Caractère précédent présent au moins n fois</td>
                        </tr>
                        <tr>
                            <td>{'{n,m}'}</td>
                            <td>Caractère précédent présent entre n et m fois</td>
                        </tr>
                        <tr>
                            <td colspan="2">Raccourcis d'écriture</td>
                        </tr>
                        <tr>
                            <td>\d</td>
                            <td>Chiffres (équivalent à [0-9])</td>
                        </tr>
                        <tr>
                            <td>\D</td>
                            <td>Sauf chiffres (équivalent à [^0-9])</td>
                        </tr>
                        <tr>
                            <td>\b</td>
                            <td>Frontière de mot (espace, alinea...)</td>
                        </tr>
                        <tr>
                            <td>\s</td>
                            <td>Caractère d'espacement (espace, tabulation, saut de page, de ligne...) équivalent à
                                [\f\n\r\t\v]</td>
                        </tr>
                        <tr>
                            <td>\S</td>
                            <td>Un seul caractère sauf un espacement</td>
                        </tr>
                        <tr>
                            <td>\w</td>
                            <td>N'importe quel caractère alphanumérique, y compris underscore(_), équivalent à
                                [A-Za-z0-9_]</td>
                        </tr>
                        <tr>
                            <td>\W</td>
                            <td>Tout sauf un caractère alphanumérique équivalent à [^A-Za-z0-9_]</td>
                        </tr>
                        <tr>
                            <td>(x)</td>
                            <td>Expression parenthésée (mémorisée pour un remplacement)</td>
                        </tr>
                    </table>


                    <div class="pageBreak"></div>
                    <h2>Les options</h2>
                    <table class="p1002080">
                       
                        
                        <tr>
                            <td>g (global)</td>
                            <td>Indique que l'expression rationnelle recherchera toutes les correspondances possibles d'une chaîne de caractères. </td>
                        </tr>
                        <tr>
                            <td>i (case insensitive)</td>
                            <td>Effectue une recherche insensible à la casse</td>
                        </tr>
                        <tr>
                            <td>m (multiline)</td>
                            <td>Par défaut, les expressions régulières considèrent la chaine dans laquelle on fait une recherche comme étant sur une seule ligne et font qu’on ne peut donc utiliser les métacaractères <strong>^</strong> et <strong>$</strong> qu’une seule fois. L’option <strong>m</strong> permet de tenir compte des caractères de retour à la ligne et de retour chariot et fait que <strong>^</strong> et <strong>$</strong> vont pouvoir être utilisés pour chercher un début et une fin de ligne</td>
                        </tr>
                        <tr>
                            <td>u (unicode)</td>
                            <td>Cette option permet de désactiver les fonctionnalités additionnelles de PCRE qui ne sont pas compatibles avec le langage Perl. Cela peut être très utile dans le cas où on souhaite exporter nos regex</td>
                        </tr>
                        <tr>
                            <td>y (sticky)</td>
                            <td>Ce marqueur indique que les correspondances ne sont recherchées qu'à partir de l'indice lastIndex au niveau de la chaîne de caractères (les correspondances à partir des autres positions ne seront pas trouvées).</td>
                        </tr>
                        <tr>
                            <td>s (single line, dotall)</td>
                            <td>Cette option permet au métacaractère <strong>.</strong> de remplacer n’importe quel caractère y compris un caractère de nouvelle ligne</td>
                        </tr>
                        
                    </table>

      </div>




    )
}